import React from 'react';
import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% { background-position: -200px 0; }
  100% { background-position: calc(200px + 100%) 0; }
`;

const SkeletonBase = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius};
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.colors.grey2} 25%,
    ${({ theme }) => theme.colors.grey3} 50%,
    ${({ theme }) => theme.colors.grey2} 75%
  );
  background-size: 200px 100%;
  animation: ${shimmer} 1.2s infinite linear;
`;

export const LoadingButton = () => (
  <SkeletonBase
    aria-label="Loading"
    style={{ width: '120px', height: '2.5rem' }}
  />
);
export const LoadingInput = () => (
  <SkeletonBase
    style={{ width: '100%', height: '2.5rem', marginBottom: '1rem' }}
    aria-label="Loading input"
  />
);
export const LoadingTextarea = () => (
  <SkeletonBase
    style={{ width: '100%', height: '5.5rem', marginBottom: '1rem' }}
    aria-label="Loading textarea"
  />
);
export const LoadingSelect = () => (
  <SkeletonBase
    style={{ width: '100%', height: '2.5rem', marginBottom: '1rem' }}
    aria-label="Loading select"
  />
);
export const LoadingLabel = () => (
  <SkeletonBase
    style={{ width: '40%', height: '1.1rem', marginBottom: '0.5rem' }}
    aria-label="Loading label"
  />
);
export const LoadingCheckbox = () => (
  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
    <SkeletonBase
      style={{ width: '1.2rem', height: '1.2rem', marginRight: '0.5rem' }}
      aria-label="Loading checkbox"
    />
    <SkeletonBase
      style={{ width: '30%', height: '1rem' }}
      aria-label="Loading checkbox label"
    />
  </div>
);

export const LoadingParagraph = () => (
  <SkeletonBase
    style={{ width: '100%', height: '1.2rem', marginBottom: '0.7rem' }}
    aria-label="Loading paragraph"
  />
);
export const LoadingTitle = () => (
  <SkeletonBase
    style={{ width: '60%', height: '2rem', marginBottom: '1rem' }}
    aria-label="Loading title"
  />
);

export const LoadingBreadcrumbs = () => (
  <SkeletonBase
    style={{ width: '220px', height: '1.2rem', marginBottom: '0.5rem' }}
    aria-label="Loading breadcrumbs"
  />
);
